// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2P7vi","row":"Node_row__2J7KR","label":"Node_label__1JnV-","footer":"Node_footer__3JitQ"};